/**
 * Date utility functions for the BestRev application
 */

/**
 * Calculates the date of Thanksgiving for a given year (4th Thursday of November in the US)
 * @param year - The year to calculate Thanksgiving for
 * @returns {Date} The date of Thanksgiving for the specified year
 */
export const getThanksgivingDate = (year: number): Date => {
	// Find the first Thursday of November
	let firstThursday = 1;
	while (new Date(year, 10, firstThursday).getDay() !== 4) {
		firstThursday++;
	}

	// Fourth Thursday is 3 weeks (21 days) later
	return new Date(year, 10, firstThursday + 21);
};

/**
 * Checks if today is Thanksgiving Day (4th Thursday of November in the US)
 * @returns {boolean} True if today is Thanksgiving, false otherwise
 */
export const isThanksgivingDay = (): boolean => {
	const today = new Date();
	const thanksgiving = getThanksgivingDate(today.getFullYear());

	return today.toDateString() === thanksgiving.toDateString();
};

/**
 * Checks if today is within the "Turkey Season" (7 days before Thanksgiving until 1 day after)
 * @returns {boolean} True if today is within the range, false otherwise
 */
export const shouldShowTurkey = (): boolean => {
	const today = new Date();
	// Reset time part to ensure accurate date comparison
	today.setHours(0, 0, 0, 0);

	const thanksgiving = getThanksgivingDate(today.getFullYear());
	thanksgiving.setHours(0, 0, 0, 0);

	const startDate = new Date(thanksgiving);
	startDate.setDate(thanksgiving.getDate() - 7);

	const endDate = new Date(thanksgiving);
	endDate.setDate(thanksgiving.getDate() + 1);

	return today >= startDate && today <= endDate;
};
